/**
 * Per-state IE (Inscrição Estadual) validation tables.
 *
 * @see Official: http://www.sintegra.gov.br/insc_est.html
 */

export const AL_PREFIXES = ["24"];

export const BA_MOD_10_DIGITS = [0, 1, 2, 3, 4, 5, 8];

export const GO_PREFIXES = ["10", "11", "15"];

export const GO_DUAL_DIGIT_IE = 11_094_402;

export const GO_SPECIAL_RANGE_START = 10_103_105;

export const GO_SPECIAL_RANGE_END = 10_119_997;

export const MA_PREFIXES = ["12"];

export const MS_PREFIXES = ["28", "50"];

export const PA_PREFIXES = ["15", "75", "76", "77", "78", "79"];

export const SP_FIRST_WEIGHTS = [1, 3, 4, 5, 6, 7, 8, 10];

export const SP_SECOND_WEIGHTS = [3, 2, 10, 9, 8, 7, 6, 5, 4, 3, 2];

export const TO_TYPES = ["01", "02", "03", "99"];
